import { PlusIcon } from "@heroicons/react/24/solid";
import { Button, Chip } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import NoData from "../../Components/Functionality/NoData";
import SortByFilter from "../../Components/Functionality/SortByFilter";
import CitationTagListPopup from "../../Components/Popup/CitationTagListPopup";
import InfoPopup from "../../Components/Popup/InfoPopup";
import CardActionButtons from "../../Components/UI/Buttons/CardActionButtons";
import ArgumentCard from "../../Components/UI/Cards/ArgumentCard";
import Container from "../../Components/UI/Container";
import LoadingSpinner from "../../Components/UI/LoadingSpinner";
import SegmentedControl from "../../Components/UI/Tabs/DebateRoundTabs";
import Tooltip from "../../Components/UI/Tooltip/Tooltip";
import { useUserStore } from "../../Context/store";
import { useSubworkspaceStore } from "../../Context/store";
import { useWorkspaceStore } from "../../Context/store";
import { getLocalTime } from "../../Utils/Helper";
import {
  useGetDebateDetails,
  useGetDebateDetailsPage,
} from "../../Web-Hooks/Debate/use-debate";
import { ReactComponent as AILogo } from "../../Assets/Svg/AILogo.svg";
import AddUpdateScalerPopup from "../Home/AddUpdateScalerPopup";
import GaugeComp from "../Home/Guage";
import ReportPopup from "./ReportPopup";
import { usePlan } from "../../Context/PlanContext";
import { useDebateSummaryAI } from "../../Web-Hooks/Agents/use-global-agents";
import DebateSummaryPopup from "../Profile/DebateSummaryPopup";
import toast from "react-hot-toast";

const DebateDetail = () => {
  const { user: loggedInUser } = useUserStore();
  const { selectedSubWorkspace } = useSubworkspaceStore();
  const { selectedWorkspace } = useWorkspaceStore();
  const location = useLocation();
  const { pathname } = location;
  const [query] = useSearchParams();
  const round = query?.get("round");
  const debateId = pathname.slice(1)?.split("/")[1];
  const { currentPlan } = usePlan();
  const [selectSide, setSelectSidePopup] = useState(false);
  const [selectedSide, setSelectedSide] = useState(null);
  const [showSummary, setShowSummary] = useState(false);
  const [sortBy, setSortBy] = useState({
    label: "All",
    value: "all",
  });
  const navigate = useNavigate();
  const { data: debateDetails, isLoading: isDebateDetailsLoading } =
    useGetDebateDetailsPage(
      debateId,
      round,
      sortBy.value,
      loggedInUser?.userId
    );
  const { data: debateSummary, isLoading: isSummaryPending } =
    useDebateSummaryAI(debateId);
  const { data: debate } = useGetDebateDetails(debateId, loggedInUser?.userId);
  const [citationPopup, setCitationPopup] = useState(false);
  const [debate1, setDebate1] = useState(null);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [reportPopup, setReportPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [userId, setUserId] = useState(null);
  const [votePopup, setVotePopup] = useState(false);
  const handleSide = (side) => {
    setSelectSidePopup(false);
    setSelectedSide(side);
  };

  const Options = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Agree",
      value: "agree",
    },
    {
      label: "Disagree",
      value: "disagree",
    },
  ];

  const isArgumentAdded = debateDetails?.filterArguments?.find(
    (user) => user?.userId === loggedInUser?.userId
  );

  useEffect(() => {
    if (debate) {
      if (
        debate?.isDebateOver === false &&
        !!debate?.isScalerVoteChecked === false
      ) {
        setVotePopup(true);
      }
    }
  }, [debate]);

  if (!debateDetails && !isDebateDetailsLoading) {
    return <NoData message={"Debate Not Found"} />;
  }
  if (isDebateDetailsLoading) {
    return (
      <Container>
        <LoadingSpinner />
      </Container>
    );
  }

  const chipValue = debateDetails?.isDebatePublic
    ? "Public"
    : debateDetails?.isDebateSemiPublic
    ? `${
        debateDetails?.subWorkspaceName
          ? `Semi-Public - ${debateDetails?.subWorkspaceName}`
          : "Semi-Public"
      }`
    : debateDetails?.isDebatePrivate
    ? "Private"
    : "";

  const isCurrentRound =
    debateDetails?.currentRound === (round ? JSON.parse(round) : false);
  const isCreator = debateDetails?.creatorId === loggedInUser?.userId;
  const isNextRoundAvailable = debateDetails?.roundStatus === "review";

  const shouldDisableButton = () => {
    const isEonian = debateDetails?.debateType === "eonian";
    const isOpenDebate = debateDetails?.isOtherUserAllow;
    const isDebateOver = debateDetails?.isDebateOver;
    if (isDebateOver) return true;
    if (isEonian && isOpenDebate) return false;
    if (
      !isCurrentRound ||
      isNextRoundAvailable ||
      (isArgumentAdded && !isEonian)
    )
      return true;
    if (isOpenDebate && !isNextRoundAvailable && !isCreator) return false;

    return true;
  };

  const isDisabled = shouldDisableButton();

  const handleSummaryPopupClick = () => {
    if (!debateSummary) {
      toast?.error("Summary is not available.");
      return;
    }
    setShowSummary(true);
  };

  return (
    <>
      <AddUpdateScalerPopup
        debate={debateDetails}
        setScalerPopup={setVotePopup}
        scalerPopup={votePopup}
        defaultValue={
          debateDetails?.userSideForDebateScalerPoint
            ? JSON.parse(debateDetails?.userSideForDebateScalerPoint)
            : 0
        }
        userSideForDebate={debateDetails?.loginUserSide?.toLowerCase()}
        defaultChecked={debateDetails?.isScalerVoteChecked}
      />
      <ReportPopup
        confirmPopup={confirmationPopup}
        setConfirmPopup={setConfirmationPopup}
        reportPopup={reportPopup}
        setReportPopup={setReportPopup}
        debateId={debateId}
        loggedInUser={loggedInUser}
        selectedSubWorkspace={selectedSubWorkspace}
        selectedWorkspace={selectedWorkspace}
        type={"Debate"}
        popupTitle={popupTitle}
        setPopupTitle={setPopupTitle}
        userId={userId}
      />
      <CitationTagListPopup
        debate={debate1}
        citationPopup={citationPopup}
        setCitationPopup={setCitationPopup}
        setDebate={setDebate1}
      />
      <DebateSummaryPopup
        closeDialog={() => setShowSummary(false)}
        isOpen={showSummary && !!debateSummary}
        debateSummary={debateSummary}
        debateInfo={debateDetails}
        handleDebateView={() => setShowSummary(false)}
      />
      <section className="overflow-y-auto flex w-full flex-col px-4 lg:px-8 py-4 justify-start items-start md:h-[calc(100dvh-8rem)]">
        <div className="flex relative flex-col h-full justify-start w-full gap-2">
          <SegmentedControl
            currentRound={
              debate?.currentRound ? JSON.parse(debate?.currentRound) : 0
            }
            totalRounds={
              debate?.totalRound ? JSON.parse(debate?.totalRound) : 0
            }
          />
          <div className="w-full flex justify-between">
            {chipValue && (
              <div className="flex gap-2 items-center">
                <Chip
                  value={chipValue}
                  className={
                    debateDetails?.isDebatePublic
                      ? "bg-public text-publicText"
                      : debateDetails?.isDebateSemiPublic
                      ? "bg-semiPublic text-semiPublicText"
                      : "bg-private text-privateText "
                  }
                />
                <span className="h-1 w-1 bg-debatePalette-title rounded-full"></span>
                <span>{getLocalTime(debateDetails?.createdAt)}</span>
              </div>
            )}
            <div className="flex gap-4 shrink-0 items-center">
              <SortByFilter
                id="argument-sort"
                Options={Options}
                setOption={setSortBy}
                defaultValue={sortBy}
              />
              {/* <Button
                disabled={debateDetails?.debateType === "eonian" ? false : disabled}
                className={`p-0 rounded-full  ${
                  debateDetails?.debateType === "eonian"
                    ? "bg-debatePalette-shadow hover:bg-debatePalette-shadow"
                    : disabled
                    ? "bg-debatePalette-border"
                    : "bg-debatePalette-shadow hover:bg-debatePalette-shadow"
                }`}
                variant="text"
              >
                <PlusIcon
                  className="text-debatePalette-background rounded-full bg-inherit  h-10 w-10 cursor-pointer"
                  onClick={() => {
                    if (debateDetails?.debateType === "eonian" && isCreator) {
                      navigate(
                        `${pathname}/add-argument?isOtherUserSide=${debateDetails?.sideForDebate}`
                      );
                      return;
                    }
                    setSelectSidePopup(true);
                  }}
                />
              </Button> */}
              {isNextRoundAvailable && isCreator && (
                <Button
                  className="bg-debatePalette-shadow flex gap-2 items-center text-debatePalette-background hover:bg-debatePalette-shadow"
                  onClick={() => {
                    navigate(
                      `/debate/${
                        debateDetails?.debateId
                      }/add-argument?roundNo=${
                        debateDetails?.currentRound + 1
                      }&isNextRound=true&userName=Add Argument`
                    );
                  }}
                >
                  Round {debateDetails?.currentRound + 1}
                </Button>
              )}

              <Tooltip
                content={"Add argument"}
                position="left"
                className="w-28"
              >
                <Button
                  disabled={isDisabled}
                  size="sm"
                  className="bg-debatePalette-shadow rounded-full p-2 flex gap-2 items-center text-debatePalette-background hover:bg-debatePalette-shadow"
                  variant="text"
                  onClick={() => {
                    if (debateDetails?.debateType === "eonian" && isCreator) {
                      navigate(
                        `${pathname}/add-argument?roundNo=0&isNextRound=true&userName=Add Argument`
                      );
                      return;
                    }

                    const loggedInUserSide =
                      debateDetails?.loginUserSide ||
                      debateDetails?.userSideForDebateForScale;

                    if (loggedInUserSide) {
                      setSelectSidePopup(false);
                      setSelectedSide(loggedInUserSide);
                      return;
                    }
                    setSelectSidePopup(true);
                  }}
                >
                  <PlusIcon className="w-6 h-6 stroke-2" />
                </Button>
              </Tooltip>
              {currentPlan?.totalAIAgent?.debatesummarizationagent && (
                <div className="flex justify-start">
                  <Button
                    size="sm"
                    variant="outlined"
                    id="debateSummaryButton"
                    disabled={isSummaryPending}
                    onClick={handleSummaryPopupClick}
                    className={` flex items-center p-1 justify-end self-end gap-2 border-[#7647FC] `}
                  >
                    <AILogo className="h-6 w-6" />
                    <span
                      className="text-[#7647FC] font-semibold animate__animated animate__fadeIn animate__faster"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Debate Summary
                    </span>
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="flex w-full justify-between items-end">
            <p className="title flex-1 text-2xl text-wrap text-debatePalette-title font-bold">
              {debateDetails?.motionOrClaim}
            </p>
            <div className="w-auto h-auto lg:w-56">
              <GaugeComp
                percentage={debateDetails?.averageVotesPercentage}
                totalVotes={debateDetails?.totalUsersAddedScalerPoint}
                handleOpen={() => setVotePopup(true)}
              />
            </div>
          </div>

          {debateDetails?.filterArguments?.map((argument, i) => (
            <ArgumentCard
              key={
                debateDetails?.debateType === "eonian"
                  ? argument?.argumentId || argument?.invitationId
                  : argument?.userId
              }
              debate={{
                ...argument,
                selectedRound: round ? round : debateDetails?.currentRound,
                totalRound: debateDetails?.totalRound,
                currentRound: debateDetails?.currentRound,
                debateId: debateDetails?.debateId,
                isOtherUserAllow: debateDetails?.isOtherUserAllow,
                subworkspaceId: debateDetails?.subworkspaceId,
                isArgumentAdded: !!isArgumentAdded,
                debateType: debateDetails?.debateType,
                isCreator: debateDetails?.creatorId === loggedInUser?.userId,
              }}
              setSelectSidePopup={setSelectSidePopup}
              setConfirmPopup={setConfirmationPopup}
              setReportPopup={setReportPopup}
              setPopupTitle={setPopupTitle}
              popupTitle={popupTitle}
              setUserId={setUserId}
            />
          ))}
          <div className="sticky bottom-0 w-full flex h-12 gap-5 bg-[#EAEAEA] justify-center rounded-md ">
            <CardActionButtons
              istooltip={`${true}`}
              debate={{
                category: debate?.fields,
                Type: debateDetails?.debateType,
                isDebateSaved: debateDetails?.isDebateSaved,
                subworkspaceId: debateDetails?.subworkspaceId,
                ...debateDetails,
              }}
              setCitationPopup={setCitationPopup}
              setDebate={setDebate1}
              currentPlan={currentPlan}
            />
          </div>
        </div>
        {selectSide && (
          <InfoPopup
            open={selectSide}
            handleClose={() => setSelectSidePopup(false)}
            title={"DebateBase"}
            btn1={"Agree"}
            btn2={"Disagree"}
            onClickBtn1={() => handleSide("agree")}
            onClickBtn2={() => handleSide("disagree")}
            description={`Motion: ${debateDetails?.motionOrClaim}`}
            description2={" Select Your Debate Side"}
          />
        )}
        {selectedSide && (
          <InfoPopup
            open={selectedSide}
            handleClose={() => setSelectedSide(null)}
            title={"DebateBase"}
            btn1={"Cancel"}
            btn2={"Yes"}
            onClickBtn1={() => setSelectedSide(null)}
            onClickBtn2={() => {
              navigate(
                `${pathname}/add-argument?isOtherUserSide=${selectedSide}`
              );
              setSelectedSide(null);
            }}
            description={`Motion: ${debateDetails?.motionOrClaim}`}
            description2={`Are you sure you want to select ${selectedSide?.toLowerCase()} side`}
            btn1Variant={"outline"}
          />
        )}
      </section>
    </>
  );
};

export default DebateDetail;
